import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useProductAllocation } from './Allocations.data'
import { AllocationsTable } from './Allocations.table'
import { max } from 'lodash'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'

export const AllocationsView = () => {
  const { projectId, scenarioId } = useParams()
  const { view_width, view_height } = useWindowSize()
  const { data, isLoading } = useProductAllocation({
    projectId: projectId ?? '',
    scenarioId: scenarioId ?? '',
  })
  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader title="Allocations" />
        <AllocationsTable
          data={data?.data ?? []}
          isLoading={isLoading}
          projectId={projectId ?? ''}
          scenarioId={scenarioId ?? ''}
          baskets={data?.baskets ?? []}
        />
      </Box>
    </Page>
  )
}
